import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form'

import { Box, TextField } from '@material-ui/core'
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab'
import { Text } from '..'
import { LoadingFeedback } from 'components'

import * as service from 'service'
import schema from './schema'

import useAuth from 'hooks/useAuth'
import useSnackbar from 'hooks/useSnackbar'
import useTrailStep from 'hooks/useTrailStep'

import useStyles from './styles'
import constants from 'constants/index'
import helpers from 'helpers'
import { InfoDialog } from '../'

const DpoAppointment = () => {
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  const [customDpo, setCustomDpo] = useState(false)
  const { handleNext } = useTrailStep()
  const classes = useStyles()
  const snackbar = useSnackbar()

  const {
    userCompany: { company },
    loadCompany,
  } = useAuth()

  const noDpo =
    !company?.dpoData?.name &&
    (company?.outsourced?.status === constants.outsourcedDpo.CANCELED_STATUS ||
      !company?.outsourced?.name)

  const { handleSubmit, control, errors } = useForm({
    validationSchema: schema(customDpo, noDpo),
    defaultValues: {
      email: '',
    },
  })

  const handleCustomDpo = (event, newDpo) => {
    if (newDpo !== null) {
      setCustomDpo(newDpo)
    }
  }

  const onSubmit = async (data) => {
    try {
      setLoading(true)
      if (noDpo && !data?.email) {
        setOpen(true)
        return
      } else if (
        data?.email !== company?.dpoData?.email &&
        (customDpo || noDpo)
      ) {
        await service.dponet.outsourcedDpo.create({
          data: {
            email: data?.email,
            companyId: company.id,
          },
        })
        await loadCompany()
      }
      handleNext()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          error?.error?.message,
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={loading} />
      <Box>
        <Text color="primary" fontSize="7vh" variant="h1">
          Nomeação do Encarregado de Proteção de Dados
        </Text>
        <Box my={6}>
          <Text fontSize="3vh" variant="h4">
            O Encarregado de Proteção de Dados é a pessoa responsável por
            intermediar a comunicação entre a organização, os titulares dos
            dados pessoais e a Autoridade Nacional de Proteção de Dados (ANPD).
          </Text>
        </Box>
        {!noDpo && (
          <ToggleButtonGroup
            value={customDpo}
            exclusive
            onChange={handleCustomDpo}
            className={classes.toggleButtonGroup}
          >
            <ToggleButton value={false} className={classes.toggleButton}>
              {company?.dpoData?.name || company?.outsourced?.name}
            </ToggleButton>
            <ToggleButton value={true} className={classes.toggleButton}>
              Personalizar
            </ToggleButton>
          </ToggleButtonGroup>
        )}
        <form id="dpo-appointment-form" onSubmit={handleSubmit(onSubmit)}>
          {(customDpo || noDpo) && (
            <Box width="100%" my={4}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    variant="outlined"
                    error={!!errors?.email}
                    helperText={errors?.email?.message}
                    className={classes.emailInput}
                    placeholder="E-mail do Encarregado (DPO)"
                  />
                }
                control={control}
                mode="onChange"
                name="email"
              />
            </Box>
          )}
        </form>
      </Box>
      <InfoDialog
        open={open}
        setOpen={setOpen}
        actionAcceptButton={() => handleNext()}
        description="A organização não possui um Encarregado de Proteção de Dados (DPO) nomeado. É necessário nomear um DPO Responsável. Essa ação pode ser realizada posteriormente no menu 'Configurações'."
        title="Aviso"
      />
    </>
  )
}

export default DpoAppointment
